export const apiUrl = '/action-log/v1/merchant-side';

export const baseUrlMapper = {
  beta: 'https://api.ronhan.com',
  development: 'https://api.ronhan.com',
  test: 'https://test-api.ronhan.com',
  testing: 'https://test-api.ronhan.com',
  sit: 'https://test-api.ronhan.com',
  uat: 'https://uat-api.ronhan.com',
  prod: 'https://api.onerway.com',
  production: 'https://api.onerway.com',
};

export const apiKeyMapper = {
  beta: '5skbadERCne5HKSS9a1EXz5RetUiEfpP',
  development: '5skbadERCne5HKSS9a1EXz5RetUiEfpP',
  test: 'Dguh5yxNDEwyQlqDmikmd7ImruaOp8c8',
  testing: 'Dguh5yxNDEwyQlqDmikmd7ImruaOp8c8',
  sit: 'Dguh5yxNDEwyQlqDmikmd7ImruaOp8c8',
  uat: 'W565QolX6clTuL1Kqgpp0JmUqBkWKY6i',
  prod: 'HUk5Kogyuv9zH5qDA2qSCjVEnhanSkf8',
  production: 'HUk5Kogyuv9zH5qDA2qSCjVEnhanSkf8',
};
